import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPlan"><Path d="M21 10H14V7.5H9.94629C8.92383 7.5 8.56047 8.85293 9.44531 9.36523L15.5566 12.9033C18.2113 14.4402 17.1211 18.5 14.0537 18.5H10V21H3V14H10V16.5H14.0537C15.0762 16.5 15.4395 15.1471 14.5547 14.6348L8.44336 11.0967C5.78874 9.5598 6.87888 5.5 9.94629 5.5H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlan;
